/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface GetMeResponse {
  userName?: string | null
  email?: string | null
  phoneNumber?: string | null
  userTenants?: UserTenantsResponse[] | null
}

export interface IdentityUserDto {
  /** @format uuid */
  id?: string
  /**
   * @minLength 1
   * @pattern ^[a-zA-Z0-9_@\-\.\+]+$
   */
  userName: string
  /**
   * @format email
   * @minLength 1
   */
  email: string
  emailConfirmed?: boolean
  phoneNumber?: string | null
  phoneNumberConfirmed?: boolean
  lockoutEnabled?: boolean
  twoFactorEnabled?: boolean
  /** @format int32 */
  accessFailedCount?: number
  /** @format date-time */
  lockoutEnd?: string | null
  userTenants?: TenantDto[] | null
}

export interface TenantDto {
  /** @format int32 */
  tenantId?: number
  tenantName?: string | null
  tenantSubdomain?: string | null
  environment?: string | null
}

export interface UserTenantsResponse {
  /** @format int32 */
  tenantId?: number
  tenantName?: string | null
  tenantSubdomain?: string | null
  businessDomainName?: string | null
}

import type { AxiosInstance, AxiosRequestConfig, HeadersDefaults, ResponseType } from 'axios'
import axios from 'axios'

export type QueryParamsType = Record<string | number, any>

export interface FullRequestParams extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean
  /** request path */
  path: string
  /** content type of request body */
  type?: ContentType
  /** query params */
  query?: QueryParamsType
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType
  /** request body */
  body?: unknown
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void
  secure?: boolean
  format?: ResponseType
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance
  private securityData: SecurityDataType | null = null
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
  private secure?: boolean
  private format?: ResponseType

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || 'https://api-dev.collaborate.center/staging/',
    })
    this.secure = secure
    this.format = format
    this.securityWorker = securityWorker
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data
  }

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method)

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    }
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem)
    } else {
      return `${formItem}`
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key]
      const propertyContent: any[] = property instanceof Array ? property : [property]

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem))
      }

      return formData
    }, new FormData())
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<T> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {}
    const requestParams = this.mergeRequestParams(params, secureParams)
    const responseFormat = format || this.format || undefined

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>)
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
      body = JSON.stringify(body)
    }

    return this.instance
      .request({
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type ? { 'Content-Type': type } : {}),
        },
        params: query,
        responseType: responseFormat,
        data: body,
        url: path,
      })
      .then((response) => response.data)
  }
}

/**
 * @title Identity Service Api
 * @version v1
 * @baseUrl https://api-dev.collaborate.center/staging/
 */
export class Api<SecurityDataType extends unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  account = {
    /**
     * No description
     *
     * @tags Account
     * @name ApiAccountMeList
     * @request GET:/identity-service/api/Account/Me
     * @secure
     */
    apiAccountMeList: (params: RequestParams = {}) =>
      this.http.request<GetMeResponse, void>({
        path: `/identity-service/api/Account/Me`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name ApiAccountTenantsList
     * @request GET:/identity-service/api/Account/{id}/tenants
     * @secure
     */
    apiAccountTenantsList: (id: string, params: RequestParams = {}) =>
      this.http.request<TenantDto, void>({
        path: `/identity-service/api/Account/${id}/tenants`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name ApiAccountByRolesList
     * @request GET:/identity-service/api/Account/by-roles
     * @secure
     */
    apiAccountByRolesList: (
      query: {
        search?: string
        roleSearch: string
      },
      params: RequestParams = {}
    ) =>
      this.http.request<IdentityUserDto, void>({
        path: `/identity-service/api/Account/by-roles`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name ApiAccountDetail
     * @request GET:/identity-service/api/Account/{userId}
     * @secure
     */
    apiAccountDetail: (userId: string, params: RequestParams = {}) =>
      this.http.request<IdentityUserDto, void>({
        path: `/identity-service/api/Account/${userId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
}
